import styled from 'styled-components'
import { SUPER_ADMIN_LABEL } from 'utils/roles'

const SuperAdminBadge = () => <Badge title='Super Admin of their organisation'>{SUPER_ADMIN_LABEL}</Badge>

export default SuperAdminBadge

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e6f8fa;
  color: #136d77;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`
